module.exports = __webpack_public_path__ + "static/media/discover-logo.c95257f9.svg";